import React from 'react';

import { SVGComponentProps } from './svg.types';

const UploadCloudSVG = ({
  fill = 'currentColor',
  size = '1.2em',
  ...otherProps
}: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3985 4.77508C12.2646 3.56316 11.694 2.44146 10.7933 1.61957C9.89266 0.79768 8.72356 0.331836 7.50448 0.309082C6.57315 0.319394 5.6638 0.593315 4.88173 1.09912C4.09966 1.60493 3.47687 2.32193 3.08548 3.16708C2.09991 3.46697 1.25244 4.10631 0.693446 4.97166C0.134456 5.837 -0.0999067 6.87239 0.0319432 7.89411C0.163793 8.91583 0.65333 9.8578 1.41369 10.5529C2.17405 11.248 3.15606 11.6512 4.18548 11.6911H10.3105C10.8034 11.6829 11.2899 11.5776 11.7422 11.3812C12.1944 11.1848 12.6034 10.9012 12.946 10.5466C13.2885 10.192 13.5578 9.77338 13.7384 9.31463C13.919 8.85588 14.0074 8.36602 13.9985 7.87308C13.9963 7.26687 13.8501 6.66985 13.5719 6.13122C13.2937 5.5926 12.8915 5.12778 12.3985 4.77508ZM4.32448 5.90908L6.69848 3.53408C6.73786 3.49465 6.78462 3.46338 6.8361 3.44203C6.88758 3.42069 6.94275 3.40971 6.99848 3.40971C7.0542 3.40971 7.10938 3.42069 7.16086 3.44203C7.21234 3.46338 7.2591 3.49465 7.29848 3.53408L9.67248 5.90908C9.73156 5.96865 9.77175 6.04433 9.78798 6.12665C9.80422 6.20896 9.79579 6.29424 9.76375 6.37178C9.7317 6.44932 9.67748 6.51567 9.60787 6.56251C9.53827 6.60936 9.45638 6.6346 9.37248 6.63508H7.84848V8.65108C7.84848 8.87652 7.75893 9.09272 7.59952 9.25212C7.44011 9.41153 7.22391 9.50108 6.99848 9.50108C6.77305 9.50108 6.55684 9.41153 6.39744 9.25212C6.23803 9.09272 6.14848 8.87652 6.14848 8.65108V6.63508H4.62548C4.5415 6.6348 4.45947 6.60969 4.38971 6.56293C4.31995 6.51616 4.26557 6.44982 4.23341 6.37224C4.20124 6.29466 4.19273 6.2093 4.20893 6.12689C4.22513 6.04449 4.26534 5.96871 4.32448 5.90908Z"
        fill="#878A92"
      />
    </svg>
  );
};

export default UploadCloudSVG;
